module.exports = __webpack_public_path__ + "03_hair_black.fb004cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/03_hair_black.png
// module id = l89Y
// module chunks = 0